// https://stackoverflow.com/questions/34351804/how-to-declare-a-global-variable-in-react
module.exports = global.config = {
	// tick_interval: 30000,
	tick_interval: 3000,
	max_ticks: 10,
	// max_ticks: 5,
	salary_cap: 20,
	player_cap: 24,
	bid_min: .05,
	rating_cscale_cap_max: 95,
	rating_cscale_cap_min: -5,
	colormap_colors_remain: 'viridis',
	colormap_colors_ranks: 'bluered',
	colormap_colors_salary_history: 'viridis',
	history_salary_cscale_cap_min: 0.05,
	history_salary_cscale_cap_max: 6.0
};
